import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-white text-lg font-heading mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">嫩草视频</Link>
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                高清流畅的在线视频平台，电影电视剧资源丰富，无需下载即点即看。
              </p>
            </div>

            <div>
              <h4 className="text-white text-base font-medium mb-4">视频分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white text-base font-medium mb-4">更多分类</h4>
              <ul className="space-y-2">
                {categories.slice(4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-base font-medium mb-4">联系我们</h4>
              <ul className="space-y-2 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@nencaovideo.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-wechat-line text-primary-400"></i>
                  <span>微信号：nencaovideo</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-400"></i>
                  <span>9:00 - 21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2025 嫩草视频 版权所有 | 本站资源仅供学习交流
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}